import React from "react";
import PropTypes from "prop-types";

class IncrDecrInput extends React.Component {
    onChange = (type) => {
        let { options, value, onChange } = this.props;
        let currentIndex = this.findClosestOptionsIndex( options, value );
        if (type === "decr") {
            if (currentIndex > 0) {
                onChange(options[currentIndex - 1].value);
            }
        } else {
            if ((currentIndex < (options.length - 1)) && (currentIndex >= 0)) {
                onChange(options[currentIndex + 1].value);
            }
        }
    };

    /**
     * find the matching or closest option, assuming value is numeric
     * and options[*].value are numeric and in ascending order.
     * Options is an array or null/undefined value.
     */
    findClosestOptionsIndex = ( options, value ) => {
        if( options ) {
            let indexEqual = options.findIndex( ( obj ) => obj.value === value ),
                indexGreater = options.findIndex( ( obj ) => obj.value > value );
            return (indexEqual >= 0) ? indexEqual : (indexGreater >= 0) ? indexGreater : options.length-1;
        } else {
            return -1;
        }
    };

    render() {
        let { options, value, className, label, btnDisplay } = this.props,
            closestOptionIndex = this.findClosestOptionsIndex( options, value );
        // render with the closest option, or if no options, render as blank value and disabled +/- buttons
        return (
            <div
                className={`tde-s1 tde-toggle-btns-wrapper ${className || ''}`}
            >
                <div
                    className={`tde-input tde-incr_decr-input tde-flex-items-center ${
                      btnDisplay ? "tde-justify-space-around" : ""
                    }`}
                >
                    <button
                        aria-label={this.props.getLoc(
                            `Decrease ${label || ""}`
                        )}
                        className="tde-font-weight-bold tde-btn "
                        onClick={() => this.onChange("decr")}
                        disabled={
                            !(closestOptionIndex > 0)
                        }
                    >
                        <i className="tde-i tde-i-decrement">
                            <span className="tde-sr-only">-</span>
                        </i>
                    </button>
                    {!btnDisplay && (
                        <input
                            tabIndex="-1"
                            aria-label={this.props.getLoc(
                                `Input Box ${label || ""}`
                            )}
                            type="text"
                            className="tde-px-1 tde-input-text tde-text-center"
                            readOnly
                            value={
                                (closestOptionIndex>=0) ? options[closestOptionIndex].label : ''
                            }
                        />
                    )}
                    <button
                        aria-label={this.props.getLoc(
                            `Increase ${this.props.label || ""}`
                        )}
                        className="tde-font-weight-bold tde-btn"
                        onClick={() => this.onChange("incr")}
                        disabled={
                            !(closestOptionIndex < (options.length - 1))
                        }
                    >
                        <i className="tde-i tde-i-increment">
                            <span className="tde-sr-only">+</span>
                        </i>
                    </button>
                </div>
            </div>
        );
    }
}

IncrDecrInput.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.any,
    options: PropTypes.array,
    label: PropTypes.string,
    className: PropTypes.string,
    getLoc: PropTypes.func,
    btnDisplay: PropTypes.bool,
};

IncrDecrInput.defaultProps = {};

export default IncrDecrInput;
